import api from './axios';

export const sessionsAPI = {
  /**
   * Получить историю сессий пользователя
   * @param {Object} params - Параметры запроса
   * @param {number} params.limit - Количество записей на странице (макс. 100, по умолчанию 50)
   * @param {number} params.offset - Смещение для пагинации (по умолчанию 0)
   * @param {string} params.status - Фильтр по статусу (active, closed)
   * @param {string} params.proxyId - Фильтр по ID прокси
   * @param {string} params.start_date - Начальная дата фильтрации (ISO 8601)
   * @param {string} params.end_date - Конечная дата фильтрации (ISO 8601)
   * @returns {Promise} Данные сессий с пагинацией
   */
  getSessions: async (params = {}) => {
    const response = await api.get('/api/v1/sessions', { params });
    return response.data;
  },

  /**
   * Получить активные сессии пользователя
   * @param {Object} params - Параметры запроса
   * @param {number} params.limit - Количество записей (по умолчанию 100)
   * @param {number} params.offset - Смещение для пагинации
   * @returns {Promise} Активные сессии
   */
  getActiveSessions: async (params = {}) => {
    const response = await api.get('/api/v1/sessions/active', { params });
    return response.data;
  },

  /**
   * Получить статистику по сессиям пользователя
   * @param {Object} params - Параметры запроса
   * @param {string} params.start_date - Начальная дата (ISO 8601)
   * @param {string} params.end_date - Конечная дата (ISO 8601)
   * @returns {Promise} Статистика по сессиям
   */
  getStats: async (params = {}) => {
    const response = await api.get('/api/v1/sessions/stats', { params });
    return response.data;
  },

  /**
   * Получить детальную информацию о сессии
   * @param {string|number} sessionId - ID сессии
   * @returns {Promise} Детальная информация о сессии
   */
  getSessionById: async (sessionId) => {
    const response = await api.get(`/api/v1/sessions/${sessionId}`);
    return response.data;
  },

  /**
   * Получить сессии по прокси
   * @param {string} proxyId - ID прокси
   * @param {Object} params - Параметры запроса
   * @param {number} params.limit - Количество записей на странице
   * @param {number} params.offset - Смещение для пагинации
   * @param {string} params.status - Фильтр по статусу
   * @returns {Promise} Сессии прокси
   */
  getProxySessions: async (proxyId, params = {}) => {
    const response = await api.get(`/api/v1/proxies/${proxyId}/sessions`, { params });
    return response.data;
  }
};
